import { Box, Typography } from '@mui/material';

const ImageTextOverlay = ({ imageSrc, text, height = 200, boxSx = {}, textSx = {}, containerSx = {} }) => (
  <Box sx={{ position: 'relative', width: { xs: 'calc(100% + 16px)', md: '100%' }, ml: { xs: -2, md: 0 }, mr: { xs: -2, md: 0 }, ...containerSx }}>
    <Box
      component="img"
      src={imageSrc}
      alt=""
      sx={{ width: '100%', height, objectFit: 'cover', borderRadius: 0, display: 'block' }}
    />
    <Box
      sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...boxSx }}
    >
      <Typography variant="h5" sx={{ color: '#fff', textShadow: '0 2px 8px rgba(0,0,0,0.5)', ...textSx }}>
        {text}
      </Typography>
    </Box>
  </Box>
);

export default ImageTextOverlay;
